import React from 'react';

import { ITrendingLink } from './types';

const TrendingLink: React.FC<ITrendingLink> = () => {
  return null;
};

export default TrendingLink;
